import {uniqueId} from 'lodash'

const vatDocsTable = {
  columns: {
    getColumnsData: 'vatDocsColumnsData',
    setColumnsData: 'setVatDocsColumnsData'
  },
  rows: {
    getRowsData: 'vatDocsRowsData',
    setRowsData: 'setVatDocsRowsData'
  }
}

const columns = [
  {
    title: 'Tax Inv. No.',
    property: 'taxInvNumber',
    typeEditable: 'inputString',
    style: 'long-input'
  },
  {
    title: 'Proforma No.',
    property: 'invoiceNumberString',
    typeEditable: 'inputString',
    style: 'long-input'
  },
  {
    title: 'Client’s Name',
    property: 'client.nickName',
    propertyWrite: 'client',
    typeEditable: 'select',
    listName: 'clientsList',
    placeholder: 'Set Client',
    list: []
  },
  {
    title: 'Invoice Amount',
    isNumber: true,
    property: 'invoiceAmount',
    typeEditable: 'inputString'
  },
  {
    title: 'Tax Period',
    property: 'taxPeriod',
    type: 'date',
    typeEditable: 'datePickerRange'
  },
  {
    title: 'Description of pending documents',
    property: 'description',
    typeEditable: 'inputString',
    style: 'long-input'
  },
  {
    title: 'Resolve',
    width: 'checkbox',
    property: 'resolve',
    viewMode: 'checkbox',
    typeEditable: 'checkbox',
    center: true
  },
  {
    property: 'action',
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false
    }
  }
]

const prefix = 'vat_docs_column_'
const vatDocsTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  col.typeTable = 'vatDocs'
  col.editable = true
  col.inputs = ['invoiceAmount']
  col.actions = {
    edit: true,
    delete: true
  }
  return col
})

export {vatDocsTable, vatDocsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/vatDocsTable.js